import React from 'react';
import { Link } from 'react-router-dom';
import { useSupplierDebts } from '../hooks/useApi';

export default function SupplierDebts() {
  const { data, isLoading } = useSupplierDebts();

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Borxhet ndaj Furnitorëve</h1>
        <div className="text-right">
          <p className="text-gray-500">Total Detyrim</p>
          <p className="text-3xl font-bold text-red-600">€{data?.total_debt?.toFixed(2)}</p>
        </div>
      </div>

      <div className="card">
        <div className="mb-4 p-4 bg-orange-50 rounded-lg">
          <p className="text-orange-800">
            ⚠️ <strong>{data?.count}</strong> furnitorë që u detyrohemi
          </p>
        </div>

        {isLoading ? (
          <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Kodi</th>
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Emri</th>
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Telefon</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Total Tarifa</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Paguar</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Detyrim</th>
                </tr>
              </thead>
              <tbody>
                {data?.suppliers?.map((supplier) => (
                  <tr key={supplier.id} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-2 font-medium">{supplier.code}</td>
                    <td className="py-3 px-2">
                      <Link to={`/suppliers/${supplier.id}`} className="text-primary-600 hover:underline">
                        {supplier.name}
                      </Link>
                    </td>
                    <td className="py-3 px-2 text-gray-500">{supplier.phone || '-'}</td>
                    <td className="py-3 px-2 text-right">€{supplier.total_fare?.toFixed(2)}</td>
                    <td className="py-3 px-2 text-right text-green-600">€{supplier.total_paid?.toFixed(2)}</td>
                    <td className="py-3 px-2 text-right font-bold text-red-600">€{supplier.balance?.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-50 font-bold">
                  <td colSpan="5" className="py-3 px-2 text-right">TOTAL:</td>
                  <td className="py-3 px-2 text-right text-red-600">€{data?.total_debt?.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
